<template>
  <v-container fluid>
    <field-form @save="create" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()">
      <h2 class="text-h4 mb-3">{{$t('domains.add.title')}}</h2>
      <template v-slot:required>
      <v-text-field id="pfid1618820415" style="max-width:800px" prepend-icon="$name" v-model="name" :rules="[v => !!v || $t('form.rules.required')]" :label="$t('domains.name')" />
      <v-select id="pfid1618820420" style="max-width:800px" :disabled="!!prefill.platform" prepend-icon="$platform" :items="platformsInt" :rules="[v => !!v || $t('form.rules.required')]" v-model="platform" :label="$t('domains.platform')" />
      <v-select id="pfid1618820423" style="max-width:800px" prepend-icon="$currency" :items="currencies" :rules="[v => !!v || $t('form.rules.required')]" v-model="currency" :label="$t('domains.currency')" />
      <v-autocomplete id="pfid1631102396"  style="max-width:800px" prepend-icon="$timezone" :items="timezones" :rules="[v => !!v || $t('form.rules.required')]" v-model="timezone" :label="$t('overview.setup.timezone')" />
      </template>
    </field-form>
    </v-container>
</template>

<script>

  import { mapState, mapGetters } from 'vuex'
  import ParseRoute from "@/mixins/parse-route";
  import FieldForm from '@/components/FieldForm';
  import Wizards from '@/mixins/wizards';
  import Formatters from "@/mixins/formatters";
  import Timezones from "@/mixins/timezones";

  export default {
    name: 'AddDomain',
    components: {FieldForm},
    mixins: [ParseRoute, Wizards, Formatters, Timezones],
    data() {
      return {
        saving: false,
        name: null,
        currency: 'CZK',
        platform: null,
        timezone: this.guessTZ()
      };
    },
    computed: {
      platformsInt() {
        return this.platforms.map(p => { return { text: this.formatPlatform(p), value: p }});
      },
      ...mapState('companies', ['item']),
      ...mapState('domains',['platforms', 'prefill']),
      ...mapGetters('domains',{currencies: 'currenciesList'}),
      ...mapGetters('companies', ['isActive']),
      ...mapGetters('auth', ['email'])
    },
    methods: {
      create() {
        var payload = {
          companyID: this.item.id,
          owner: this.item.owner,
          editors: this.item.editors,
          currency: this.currency,
          name: this.name,
          platform: this.platform,
          timezone: this.timezone,
          capabilities: {
            allow: this.isActive
          }
        };
        /*
        if(this.platform == 'SHOPIFY' && this.shopifyStore) {
          payload.productFeedURL = this.shopifyStore;
        }
        */
        payload = Object.assign(payload, this.prefill ?? {}); 

        this.saving = true;
        this.$store.dispatch('domains/create', payload)
        .then((d) => { 
          this.saving = false; 
          // no await, no return - we do not have to wait for this
          this.$store.dispatch('domains/createACDeal', {
            contactEmail: this.email,
            companyId: this.item.id,
            domainId: d.id,
            name: this.name,
            companyName: this.item.name,
            country: this.item.country,
            currency: this.currency,
            platform: this.platform,
            registered: new Date(),
            companyRegistered: this.item.createdAt
          })
          this.nextStep({ domain: d.id }) })
        .catch(e => { console.error(e); this.saving = false; this.$store.dispatch('ui/notify', { text: this.$t('form.errors.unexpected'), error: true}) })
      },
    },
    created() {
      this.$store.commit('ui/wizard', {value: true });
      
      Object.entries(this.prefill ?? {}).forEach(([k,v]) => {
        if(k in this) {
          this.k = v;
        }
      })
      /*
      if(this.prefill?.platform) {
        this.platform = this.prefill.platform;
      }
      */
      if(!this.currencies.find(c => c.value == this.currency)) {
        this.currency = 'CZK';
        this.$store.dispatch('ui/notify', {error: true, text: this.$t('domains.errors.currency')})
      }
    }
  }
</script>
